import * as React from 'react'

import { withPrefix } from 'gatsby'
import { Image as ImageBase, ImageProps } from '@chakra-ui/react'

export type ImageProps = ImageProps & {}

const Image: React.FC<ImageProps> = ({ src, ...others }) => {
  return (
    <>
      <ImageBase src={withPrefix(src)} {...others} />
    </>
  )
}

export default Image
